import React from 'react';
import styled from 'styled-components';
import { Red, Green, Sub } from '../../components/Text';
import dfstyles from '../../styles/dfstyles';
import { Planet, Upgrade } from '../../_types/global/GlobalTypes';
import { RightarrowIcon } from '../Icons';

const StyledUpgradePreview = styled.div`
  min-width: 15em;
  width: 100%;
`;

const StatRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  &.statrow-mtop {
    margin-top: 0.5em;
  }

  & > span {
    margin-left: 0.2em;

    &:nth-child(1) {
      color: ${dfstyles.colors.subtext};
      margin-left: 0;
      width: 9em;
    }
    &:nth-child(2),
    &:nth-child(4) {
      text-align: center;
      width: 6em;
      flex-grow: 1;
    }
    &:nth-child(3) {
      // arrow
      text-align: center;
      width: 1.5em;
      & svg path {
        fill: ${dfstyles.colors.subtext};
      }
    }
    &:nth-child(5) {
      width: 5em;
      text-align: right;
    }
  }

  &.upgrade-willupdate {
    background: ${dfstyles.colors.backgroundlight};
  }
`;

const StatRowFilled = ({
  planet,
  upgrade,
  title,
  stat,
  className,
}: {
  planet: Planet | null;
  upgrade: Upgrade | null;
  title: string;
  stat: string;
  className?: string;
}) => {
  const getStat = (stat: string): number => {
    if (!planet) return 0;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mySelected = planet as any;

    if (stat === 'silverGrowth') return mySelected[stat] * 60;
    else return mySelected[stat];
  };
  const statNow = (stat: string): string => {
    const num = getStat(stat);
    if (num % 1.0 === 0) return num.toFixed(0);
    else return num.toFixed(2);
  };
  const getStatFuture = (stat: string): number => {
    if (!planet) return 0;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mySelected = planet as any;

    if (!upgrade) return mySelected[stat];

    let mult = 1;
    if (stat === 'energyCap') {
      mult = upgrade.energyCapMultiplier / 100;
    } else if (stat === 'energyGrowth') {
      mult = upgrade.energyGroMultiplier / 100;
    } else if (stat === 'range') {
      mult = upgrade.rangeMultiplier / 100;
    } else if (stat === 'speed') {
      mult = upgrade.speedMultiplier / 100;
    } else if (stat === 'defense') {
      mult = upgrade.defMultiplier / 100;
    }

    return getStat(stat) * mult;
  };
  const statFuture = (stat: string): string => {
    const num = getStatFuture(stat);
    if (num % 1.0 === 0) return num.toFixed(0);
    else return num.toFixed(2);
  };
  const getStatDiff = (stat: string): number => {
    return getStatFuture(stat) - getStat(stat);
  };
  const statDiff = (stat: string): React.ReactNode => {
    const diff: number = getStatDiff(stat);
    if (diff < 0) return <Red>{diff.toFixed(2)}</Red>;
    else if (diff > 0) return <Green>+{diff.toFixed(2)}</Green>;
    else return <Sub>0</Sub>;
  };

  const updateClass = (stat: string): string => {
    if (getStat(stat) !== getStatFuture(stat)) return 'upgrade-willupdate';
    return '';
  };

  return (
    <StatRow className={[className, updateClass(stat)].join(' ')}>
      <span>{title}</span>
      <span>{statNow(stat)}</span>
      <span>
        <RightarrowIcon />
      </span>
      <span>{statFuture(stat)}</span>
      <span>{statDiff(stat)}</span>
    </StatRow>
  );
};

export function UpgradePreview({
  planet,
  upgrade,
}: {
  planet: Planet | null;
  upgrade: Upgrade | null;
}) {
  return (
    <StyledUpgradePreview>
      <StatRowFilled
        planet={planet}
        upgrade={upgrade}
        stat='energyCap'
        title='Energy Cap'
      />
      <StatRowFilled
        planet={planet}
        upgrade={upgrade}
        stat='energyGrowth'
        title='Energy Growth'
      />
      <StatRowFilled
        planet={planet}
        upgrade={upgrade}
        className='statrow-mtop'
        title='Range'
        stat='range'
      />
      <StatRowFilled
        planet={planet}
        upgrade={upgrade}
        className='statrow-mtop'
        title='Speed'
        stat='speed'
      />
      <StatRowFilled
        planet={planet}
        upgrade={upgrade}
        className='statrow-mtop'
        title='Defense'
        stat='defense'
      />
    </StyledUpgradePreview>
  );
}
